import { Person, Business, Description, GroupWork, Payment } from '@mui/icons-material';
import { Stepper, Step, StepLabel, StepIconProps } from '@mui/material';

import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

import '../styles/Register.scss';

interface Props {
  activeStep: number;
}

function PersonStepIcon(props: StepIconProps) {
  return <Person />;
}

function BusinessStepIcon(props: StepIconProps) {
  return <Business />;
}

function PaymentStepIcon(props: StepIconProps) {
  return <Payment />;
}

function DescriptionStepIcon(props: StepIconProps) {
  return <Description />;
}

function GroupWorkStepIcon(props: StepIconProps) {
  return <GroupWork />;
}

export default function RegisterStepper({ activeStep }: Props) {
  const { t } = useTranslation();

  return (
    <Stepper alternativeLabel activeStep={activeStep} className="register-form__steps__stepper">
      <Step key={0}>
        <StepLabel
          StepIconComponent={PersonStepIcon}
          className={clsx({
            'register-form__steps__stepper--active': activeStep === 0,
            'register-form__steps__stepper--done': activeStep > 0
          })}
        >
          {t(translations.pages.login.formSteps.contact())}
        </StepLabel>
      </Step>
      <Step key={1}>
        <StepLabel
          StepIconComponent={BusinessStepIcon}
          className={clsx({
            'register-form__steps__stepper--active': activeStep === 1,
            'register-form__steps__stepper--done': activeStep > 1
          })}
        >
          {t(translations.pages.login.formSteps.company())}
        </StepLabel>
      </Step>
      <Step key={2}>
        <StepLabel
          StepIconComponent={PaymentStepIcon}
          className={clsx({
            'register-form__steps__stepper--active': activeStep === 2,
            'register-form__steps__stepper--done': activeStep > 2
          })}
        >
          {t(translations.pages.login.formSteps.invoice())}
        </StepLabel>
      </Step>
      <Step key={3}>
        <StepLabel
          StepIconComponent={DescriptionStepIcon}
          className={clsx({
            'register-form__steps__stepper--active': activeStep === 3,
            'register-form__steps__stepper--done': activeStep > 4
          })}
        >
          {t(translations.pages.login.formSteps.companyDescription())}
        </StepLabel>
      </Step>
      <Step key={4}>
        <StepLabel
          StepIconComponent={GroupWorkStepIcon}
          className={clsx({
            'register-form__steps__stepper--active': activeStep === 4
          })}
        >
          {t(translations.pages.login.formSteps.faculties())}
        </StepLabel>
      </Step>
    </Stepper>
  );
}
